import styled from 'styled-components';
import { Button } from 'antd';

export const ButtonStyled = styled(Button)<{$isFirstResponse: boolean}>`
  margin-top: ${({ $isFirstResponse }) => {
    return $isFirstResponse ? '0.6rem' : '0rem';
  }};
  margin-left: ${({ $isFirstResponse }) => {
    return $isFirstResponse ? '2.7rem' : '0rem';
  }};
  text-align: left;
  cursor: pointer;
  padding: 0;
  text-transform: uppercase;
  font-size: 0.8rem;
  font-weight: 600;
  white-space: nowrap;
  background: none;
  color: ${({ theme }) => theme.baseBlue.a10};
  border: none;
  &:hover,
  :focus {
    color: ${({ theme }) => theme.baseBlue.a8};
    background: none;
    border: none;
  }
`;

export const ResponseWrapper = styled.div<{ $isCommentStyle?: boolean }>`
  margin-left: ${({ $isCommentStyle }) => {
    return $isCommentStyle ? '17px' : '0px';
  }};
`;

export const CommentForm = styled.div`
  display: flex;
  margin-top: 1rem;
`;

export const CommentWrapper = styled.div<{$isExistingResponse: boolean}>`
  flex-grow: 1;
  margin-left: ${({ $isExistingResponse }) => {
    return $isExistingResponse ? '2.8rem' : '0px';
  }};
`;

export const ResponseLists = styled.div`
  display: flex;
  margin-top: 0.5rem;
  align-items: start;
`;

export const ResponseText = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ActionButtonContainer = styled.div`
  display: flex;
  position: absolute;
  right: 4px;
  top: 4px;
`;

export const ResponseDate = styled.div.attrs({ className: 'caption_text' })`
  margin-top: 0.4rem;
  color: ${({ theme }) => theme.baseBlue.a6};
`;

export const ResponseBody = styled.div`
  position: relative;
  margin-left: 15px;
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 8px 11px;
  color: ${({ theme }) => theme.baseBlue.a10};
`;

export const RightSection = styled.div`
  margin-left: 10px;
`;

export const AnchorStyled = styled.a<{ $isFocused?: boolean }>`
  color: ${({ theme }) => theme.baseBlue.a10};
  text-transform: uppercase;
  font-size: 0.8rem;
  font-weight: 600;
  margin-top: 2px;
  margin-right: 8px;
  margin-left: ${({ $isFocused }) => {
    return $isFocused ? '12px' : '4px';
  }};
  opacity: ${({ $isFocused }) => {
    return $isFocused ? '' : '0.7';
  }};
  &:hover {
    color: ${({ theme }) => theme.baseBlue.a8};
  }
`;

export const ResponderName = styled.div`
  color: ${({ theme }) => theme.baseBlue.a8};
  line-height: 26px;
  margin-bottom: 0.2rem;
`;
